import { tmsProductData } from './tms-products';
import { booksBlog } from './tms-blogs-book';
import { parentingBlog } from './tms-blogs-parenting';
import { electronicsBlog } from './tms-blogs-electronics';
import { homeDecor } from './tms-blogs-home-decor';

export const tmsData = {
	sliderData: {
		"id": 1,
		"image": "/assets/img/slider/single-slider-12.png",
		"backgroundImage": "/assets/img/icon-img/snow1.png",
		"backgroundImage1": "/assets/img/slider/slider-35.jpg",
		"title": "Christmas Sale",
		"subtitle": "New Year Offer <br /> Collection",
		"url": "/shop-grid-standard",
		"affiliateUrl": "https://amzn.to/3M6kiEP",
		"absoluteUrl": "https://m.media-amazon.com/images/G/31/img22/Wireless/Samsung/Jup_22/Associates/Ph-2/P2_Associates_2148x588_2.jpg"
	},
	blogThumbnails: [],
	homePageRecommendations: [],
	blogs: [
		booksBlog.booksInspireEntrepreneurship,
		booksBlog.booksPersonalGrowth,
		booksBlog.booksPersonalFinance,
		booksBlog.booksForTeenager,
		booksBlog.booksToGift,
		booksBlog.booksForKids6To10,
		booksBlog.booksToForKids6To10Fun,
		booksBlog.booksFiction,
		booksBlog.booksFromDesiretoDestiny,
		booksBlog.booksMentalWellness,
		booksBlog.bookMysteries,

		parentingBlog.returnGiftIdeas,
		parentingBlog.giftIdeasFor0To1YearOld,

		homeDecor.idea1,

		electronicsBlog.mobileUnder15,
		electronicsBlog.mobileUnder30,
		electronicsBlog.bestLaptops,
		electronicsBlog.bestLaptopsForStudents,
		electronicsBlog.bestGamingLaptops,
		electronicsBlog.tvUnder30,
		electronicsBlog.tvUnder50,
		electronicsBlog.cameraUnder80,
		electronicsBlog.bluetoothEarbudsUnder2k,
		electronicsBlog.monitorUnder20k,
		electronicsBlog.mouseUnder1k,
		electronicsBlog.pendrive1k,
		electronicsBlog.smartwatch5k

	]
}